import styled, { css } from 'styled-components';
import React from 'react';

export const CardProducElement = styled.div`
  ${({ theme, ...props }) => {
    return css`
      background: ${theme.color.primary_100};
      border-radius: ${theme.radius.sm};
      overflow: hidden;

      display: flex;
      flex-direction: column;
      box-shadow: ${theme.box_shadow.sm};

      @media screen and (min-width: ${theme.breakpoint.xl}) {
        flex-direction: row;
        justify-content: space-between;
      }
    `;
  }};
`;

export const CardProductImage = styled.div`
  ${({ theme, ...props }) => {
    return css`
      position: relative;
      width: 100%;

      // Desktop
      @media screen and (min-width: ${theme.breakpoint.xl}) {
        //max-width: 20rem;
        max-width: 16rem;
        flex-shrink: 0;
      }

      // CardImage
      > div:first-child {
        @media screen and (min-width: ${theme.breakpoint.xl}) {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;

          height: 100%;
        }
      }
    `;
  }};
`;

export const BadgesContainer = styled.div`
  ${({ theme, ...props }) => {
    return css`
      position: absolute;
      top: 0.5rem;
      left: 0;
      width: 100%;
      padding: 0 0.5rem;
      > span {
        display: inline-block;
        box-shadow: ${theme.box_shadow.base};
      }
    `;
  }};
`;

export const CardProductDetail = styled.div`
  ${({ theme, ...props }) => {
    return css`
      //border: 1px dotted deeppink;
      padding: 1rem;

      // Desktop
      @media screen and (min-width: ${theme.breakpoint.xl}) {
        padding: 1rem 1rem 0 1rem;
        width: 100%;
      }
    `;
  }};
`;

export const CardProductPriceCta = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      gap: 0.5rem;
      padding: 1rem;

      color: ${theme.color.white};
      background-color: ${theme.color.secondary_600};
      //background-color: ${theme.color.secondary_200};

      // PriceContainer
      > div {
        //border: 1px dotted white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        sup {
          font-size: 0.75rem;
          top: -1rem;
        }
      }

      // Desktop
      @media screen and (min-width: ${theme.breakpoint.sm}) {
        padding: 1rem;
        min-width: 16rem;
      }
    `;
  }};
`;
